module.exports = __webpack_public_path__ + "img/Bishop.59e48077.jpg";